import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {contactsLearnMoreUrl} from '../../../../../../../../src/helpers/contactsManagerHelpers';
import {openInBrowser} from '../../../../../../../../srcCommon/browser/openInBrowser';
import {Handler} from '../../../../../../../shared/helpers/src/react/reactHelpers';
import {InfoBox} from './infoBox';

/*
 * Props.
 */

interface CompanyContactsInfoBoxesProps {
  onRequestClose: Handler;
}

/*
 * Styles.
 */

const StyledInfoBoxWrapperDiv = styled.div`
  padding: 15px 53px 24px 0px;
  background: ${(p) => p.theme.greys.white};
  margin-left: -12px;
`;

/*
 * Component.
 */

export const CompanyContactsInfoBoxes: FC<CompanyContactsInfoBoxesProps> = (props) => {
  const {onRequestClose} = props;
  const onLearnMoreClick = () => openInBrowser(contactsLearnMoreUrl);

  return (
    <StyledInfoBoxWrapperDiv>
      <InfoBox
        title={<Trans id="company-contacts-infobox-title">What are company contacts?</Trans>}
        footer={<Trans id="company-contacts-infobox-learn-more-link">Learn more</Trans>}
        onFooterClick={onLearnMoreClick}
        onRequestClose={onRequestClose}
      >
        <Trans id="company-contacts-infobox-body">
          Contacts that you add to this list will be shared with everyone in your company. This allows your
          team to keep a single source of truth for your contacts.
        </Trans>
      </InfoBox>
    </StyledInfoBoxWrapperDiv>
  );
};
